import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { SearchFiltersOthersModal } from './SearchFiltersOthersModal';
import { useModal } from '../../../../components/modal/useModal';
import { reportFilterToggle } from '../../mobile-actions/filtersUtils';
import { TextButton } from '../../../../components/button';

type Props = {
  count: number;
  track: Function;
};

export const SearchFiltersOthers: FC<Props> = ({ count }) => {
  function onClose(onRequestClose: Function) {
    return () => {
      reportFilterToggle('arret', 'others', false);
      onRequestClose();
    };
  }

  const { openModal } = useModal(({ onRequestClose, ...modalProps }) => (
    <SearchFiltersOthersModal
      onRequestClose={onClose(onRequestClose)}
      {...modalProps}
    />
  ));

  function onClick() {
    reportFilterToggle('arret', 'others', true);
    openModal();
  }

  return (
    <TextButton onClick={onClick}>
      <FormattedMessage id="search/components/search-filters-bar/others/SearchFiltersOthers/1" />
      {count > 0 && (
        <span>
          {'\u00A0'}({count})
        </span>
      )}
    </TextButton>
  );
};
